export type RtoRequiredDownType = "payments" | "percent";

export type RtoTermDefinition = {
  id: string;
  name: string;
  term_months: number;
  divisor: number;
  required_down_type: RtoRequiredDownType;
  required_down_value: number;
  balloon_required: boolean;
  balloon_payments: number;
  early_purchase_percent: number;
  /** Optional per-state override map, e.g. { "SC": 0.58, "NC": 0.62 }. */
  early_purchase_percent_by_state?: Record<string, number>;
};

export const DEFAULT_RTO_TERMS: RtoTermDefinition[] = [
  {
    id: "rto-24",
    name: "24 Mo",
    term_months: 24,
    divisor: 16.8,
    required_down_type: "payments",
    required_down_value: 2,
    balloon_required: false,
    balloon_payments: 0,
    early_purchase_percent: 0.62,
  },
  {
    id: "rto-36",
    name: "36 Mo",
    term_months: 36,
    divisor: 25.2,
    required_down_type: "payments",
    required_down_value: 3,
    balloon_required: false,
    balloon_payments: 0,
    early_purchase_percent: 0.58,
  },
  {
    id: "rto-48",
    name: "48 Mo",
    term_months: 48,
    divisor: 33.6,
    required_down_type: "payments",
    required_down_value: 4,
    balloon_required: false,
    balloon_payments: 0,
    early_purchase_percent: 0.55,
  },
];

function storageKey(orgId: string) {
  return `bb-rto-terms-${orgId}`;
}

export function loadRtoTermsForOrg(orgId: string): RtoTermDefinition[] {
  try {
    const raw = window.localStorage.getItem(storageKey(orgId));
    if (!raw) return DEFAULT_RTO_TERMS;
    const parsed = JSON.parse(raw) as RtoTermDefinition[];
    if (!Array.isArray(parsed) || !parsed.length) return DEFAULT_RTO_TERMS;
    return parsed.filter((row) => row && typeof row.id === "string");
  } catch {
    return DEFAULT_RTO_TERMS;
  }
}

export function saveRtoTermsForOrg(orgId: string, terms: RtoTermDefinition[]) {
  window.localStorage.setItem(storageKey(orgId), JSON.stringify(terms));
  window.dispatchEvent(new CustomEvent("rto-terms-saved", { detail: { organizationId: orgId } }));
}

export function cacheRtoTermsForOrg(orgId: string, terms: RtoTermDefinition[]) {
  try {
    window.localStorage.setItem(storageKey(orgId), JSON.stringify(terms));
  } catch {
    // ignore
  }
}
